import { WIDGET_TYPES } from "./constants";
import Main from "./Main";

const NeetoWidget = { EmbedCode: Main, WIDGET_TYPES };

export default NeetoWidget;
